<script setup lang="ts">

import iconSolution from "@/components/icons/iconSolution.vue";
import iconChemicals from "@/components/icons/iconChemicals.vue";
import iconManufactured from "@/components/icons/iconManufactured.vue";
import iconManufacturing from "@/components/icons/iconManufacturing.vue";
import iconSupportWaste from "@/components/icons/iconSupportWaste.vue";
import iconIndustry from "@/components/icons/iconIndustry.vue";
import iconApplications from "@/components/icons/iconApplications.vue";


import Tag from "primevue/tag";

import { vwWithMax } from '@/utility/utility';

const route = useRoute()

const emit = defineEmits<{
  (e: 'toggle'): void
}>()

const router = useRouter()

function redirect(path: string) {
  router.push(path)

  nextTick(() => {
    emit('toggle')
  })
}

const defultWidth = computed(() => vwWithMax(75, 1300) + "px");
</script>

<template>
<Section id="mega-solutions" class="io-mega-popover sec-popover-container popover-solutions mega-solutions" w="w-full">
  <Section class="sec-mega-container" w="flex g-1 gpb-0.5 max-w-98% mx-auto">
    <Column class="flex-1" w="grid g-0.5">
      <div class="mega-column-title">
          <div>Chemistry</div>
      </div>
      <div class="sec-link-cards grid !g-0.75">
        <a class="sec-nav-card-link feature" :class="{'active': route.name === 'solutions-ethanol-blending'}" @click="redirect('/solutions/ethanol-blending')">
          <div class="wrap">
            <div class="icon">
              <iconSolution class="cc-icon ethanol" />
            </div>
            <div class="productLinkContent">
              <h3 class="linkTitle">Tailored Ethanol Blending</h3>
              <p class="linkSub">We offer environmentally-conscious ethanol blends prioritizing efficiency and sustainability.</p>
            </div>
          </div>
        </a>
        <a class="sec-nav-card-link feature" :class="{'active': route.name === 'solutions-essential-chemicals'}" @click="redirect('/solutions/essential-chemicals')">
          <div class="wrap">
            <div class="icon">
              <iconChemicals class="cc-icon chemical" />
            </div>
            <div class="productLinkContent">
              <h3 class="linkTitle">Essential Chemicals</h3>
              <p class="linkSub">These chemicals are foundational and drive innovation in many applications.</p>
            </div>
          </div>
        </a>
        <a class="sec-nav-card-link feature" :class="{'active': route.name === 'solutions-manufactured-products'}" @click="redirect('/solutions/manufactured-products')">
          <div class="wrap">
            <div class="icon">
              <iconManufactured class="cc-icon manufactured" />
            </div>
            <div class="productLinkContent">
              <h3 class="linkTitle">Manufactured Products</h3>
              <p class="linkSub">Every product is meticulously designed for optimal results tailored to specific use cases.</p>
            </div>
          </div>
        </a>
      </div>
    </Column>
    <Column class="flex-1" w="grid g-0.5">
      <div class="mega-column-title">
          <div>Services</div>
      </div>
      <div class="sec-link-cards grid !g-0.75">
        <a class="sec-nav-card-link feature" :class="{'active': route.name === 'solutions-manufacturing-as-a-service'}" @click="redirect('/solutions/manufacturing-as-a-service')">
          <div class="wrap">
            <div class="icon">
              <iconManufacturing class="cc-icon manufacturing" />
            </div>
            <div class="productLinkContent">
              <h3 class="linkTitle">Manufacturing as a Service</h3>
              <p class="linkSub">Our tailored manufacturing solutions cater to various sectors.</p>
            </div>
          </div>
        </a>
        <a class="sec-nav-card-link feature" :class="{'active': route.name === 'solutions-hazardous-waste-solutions'}" @click="redirect('')">
          <div class="wrap">
            <div class="icon">
              <iconSupportWaste class="cc-icon support" />
            </div>
            <div class="productLinkContent">
              
              <h3 class="linkTitle">Hazardous Waste Solutions </h3>
              <p class="linkSub gmb-1">We see hazardous waste as an opportunity. Our approaches transform waste into environmental milestones.</p>
              <Tag class="tag-soon max-w-100px gmt-0.25">Coming Soon</Tag>
            </div>
          </div>
        </a>
        
      </div>
    </Column>
    <Column class="flex-1" w="grid g-0.5">

      <div class="mega-column-title">
          <div>Industries & Applications</div>
      </div>
      <div class="sec-link-cards grid !g-0.75">
        <a class="sec-nav-card-link feature" :class="{'active': route.name === 'industries'}" @click="redirect('/industries')">
          <div class="wrap">
            <div class="icon">
              <iconIndustry class="cc-icon industry" />
            </div>
            <div class="productLinkContent">
              <h3 class="linkTitle">Industry Specific Solutions</h3>
              <p class="linkSub">From pharmaceuticals to textiles, we enhance industry standards with our expertise.</p>
            </div>
          </div>
        </a>
        <a class="sec-nav-card-link feature" :class="{'active': route.name === 'applications'}" @click="redirect('/applications')">
          <div class="wrap">
            <div class="icon">
              <iconApplications class="cc-icon applications" />
            </div>
            <div class="productLinkContent">
              <h3 class="linkTitle">Applications</h3>
              <p class="linkSub">Each application is a building block to efficient solutions. We craft tailored chemical solutions to meet specific needs.</p>
            </div>
          </div>
        </a>
      </div>
    </Column>
  </Section>
</Section>
</template>

<style lang="scss" scoped>

#mega-solutions {
  width: v-bind(defultWidth);

  .tag-soon {
    background: #f1f5f9;
    font-size: fs(-3);
    padding: 0.12rem 0.4rem;
    color: #475569;
    @apply rounded-md;
  }

  .sec-nav-card-link {
    &.feature {
      .wrap {
        .icon {
          svg {
            width: 24px;
            height: auto;

            &.ethanol {
              * {
                fill: var(--blue-500);
              }
            }

            &.chemical {
              * {
                fill: var(--purple-800);
              }
            }

            &.manufactured {
              * {
                fill: var(--emerald-500);
              }
            }
          }


        }
      }
    }
  }
}
</style>